import { defineEvent } from '../types/event';
export var PRODUCT_CARDS_IN_UPSELL_CAROUSEL_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Clicks_on_product_cards_in_upsell_carousel'
        }
    ]
});
